import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { delay } from "./Utils";

const CreateJobDescription = (htmlEditor) => {
  // get the submission form
  const form = document.getElementById("create_job_description");
  if (form) {
    // sending data ui elements
    const spinner = form.querySelector("button[type=submit] svg");
    const spinnerText = form.querySelector("button[type=submit] span");

    // onSubmit
    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      // update sending data ui status
      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Saving...";

      // build form data
      const data = new FormData(form);
      data.append("action", "create_job_description");
      data.append("myObjectives", htmlEditor.getContents());

      fetch(`/wp-admin/admin-ajax.php`, {
        method: "POST",
        body: data,
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          ((a = document.createElement("a")), (d = new Date()));
          a.href = window.URL.createObjectURL(blob);
          a.download = `job-description-${d.getTime()}.pdf`;
          a.click();
          delay(1000).then(() => {
            // reset ui
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Generate Job Description";
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
        });
    });
  }
};

export { CreateJobDescription };
